import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Profiles.css";
import logo from "./assets/logo.png";
import click from "./assets/sounds/click.mp3";
import { usePreferences } from "./hooks/usePreferences";
import { useTranslation } from "react-i18next";

import avatar1 from "./assets/avatars/avatar1.png";
import avatar2 from "./assets/avatars/avatar2.png";
import avatar3 from "./assets/avatars/avatar3.png";
import avatar4 from "./assets/avatars/avatar4.png";
import avatar5 from "./assets/avatars/avatar5.png";
import avatar6 from "./assets/avatars/avatar6.png";
import avatar7 from "./assets/avatars/avatar7.png";
import avatar8 from "./assets/avatars/avatar8.png";
import avatar9 from "./assets/avatars/avatar9.png";
import avatar10 from "./assets/avatars/avatar10.png";
import avatar11 from "./assets/avatars/avatar11.png";
import avatar12 from "./assets/avatars/avatar12.png";


const avatarList = [
  avatar1, avatar2, avatar3, avatar4, avatar5, avatar6,
  avatar7, avatar8, avatar9, avatar10, avatar11, avatar12
];

export default function Profiles({ token }) {
  const navigate = useNavigate();
  const [profiles, setProfiles] = useState([]);
  const [editingProfile, setEditingProfile] = useState(null);
  const [newPseudo, setNewPseudo] = useState("");
  const [newAvatarIndex, setNewAvatarIndex] = useState(null);
  const [newLangue, setNewLangue] = useState("fr");
  const [error, setError] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const { soundEnabled, timerSoundEnabled } = usePreferences(token);

  const API_URL = process.env.REACT_APP_API_URL;
  const timerAudioRef = useRef(null); // 🔊 ref pour le son tic-tac
  const { t, i18n } = useTranslation();

  const fetchProfiles = async () => {
    try {
      const res = await fetch(`${API_URL}/api/profiles`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw { code: "PROFILES_FETCH_ERROR" };
      const data = await res.json();
      setProfiles(data);
        } catch (err) {
      setError(err.message || t("errors.profilesFetch"));
    }
  };

  useEffect(() => {
    if (token) fetchProfiles();
  }, [token]);

  const handleSave = async () => {
    try {
      const body = {
        pseudo: newPseudo,
        avatar: avatarList[newAvatarIndex] || avatar1,
        preferredLanguage: newLangue,
      };

      if (editingProfile?.id) {
        await fetch(`${API_URL}/api/profiles/${editingProfile.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify(body),
        });
      } else {
        await fetch(`${API_URL}/api/profiles`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify(body),
        });
      }

      setEditingProfile(null);
      setNewPseudo("");
      setNewAvatarIndex(null);
      setNewLangue("fr");
      fetchProfiles();
    } catch (err) {
      setError(err.message || t("errors.profileSave"));
    }
  };

  const playSound = (sound, isTimer = false) => {
    if ((isTimer && !timerSoundEnabled) || (!isTimer && !soundEnabled)) return;

    if (isTimer) {
      // stoppe un éventuel son déjà lancé
      if (timerAudioRef.current) {
        timerAudioRef.current.pause();
        timerAudioRef.current.currentTime = 0;
      }
      timerAudioRef.current = new Audio(sound);
      timerAudioRef.current.loop = true; // tic-tac en continu
      timerAudioRef.current.play();
    } else {
      const audio = new Audio(sound);
      audio.play();
    }
  };


  const handleDelete = async (id) => {
    try {
      await fetch(`${API_URL}/api/profiles/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchProfiles();
    } catch (err) {
  setError(err.message || t("errors.profileDelete"));
}

  };

  return (
    <div className="profiles-container">
      <img src={logo} alt="VinOdys’sait" className="logo_3" />
      <h1
        className="edit-toggle"
        onClick={() => setIsEditing(!isEditing)}
        style={{ cursor: "pointer" }}
      >
        {isEditing ? t("profiles.done") : t("profiles.edit")}
      </h1>

      <h2>{t("profiles.chooseProfile")}</h2>
      {error && <p className="error-msg">{error}</p>}

      {editingProfile === null ? (
        <>
          <div className="profiles-grid">
            {profiles.map((profile) => (
              <div key={profile.id} className="profile-card">
                <img
  src={profile.avatar}
  alt={profile.pseudo}
  className="avatar clickable"
  onClick={() => {
    if (isEditing || editingProfile !== null) {
      setEditingProfile(profile);
      return;
    }
    i18n.changeLanguage(profile.preferredLanguage);
    navigate("/gameChoice", { state: { token, profile } });
  }}
/>
                <h3>{profile.pseudo}</h3>

                {isEditing && (
                  <div className="button-group-2">
                    <button
                      className="bg-Purple-600"
                      onClick={() => {
                        setEditingProfile(profile);
                        setNewPseudo(profile.pseudo);
                        const index = avatarList.indexOf(profile.avatar);
                        setNewAvatarIndex(index !== -1 ? index : 0);
                        setNewLangue(profile.preferredLanguage);
                        playSound(click);
                      }}
                    >
                      {t("profiles.edit")}
                    </button>
                    <button
                      className="bg-White-650"
                      onClick={() => {
                        playSound(click);
                        handleDelete(profile.id);
                      }}
                    >
                      {t("profiles.delete")}
                    </button>
                  </div>
                )}
              </div>
            ))}

            {profiles.length < 4 && isEditing && (
              <div className="profile-card new-profile">
                <div className="button-group-2">
                  <button
                    className="bg-Purple-600"
                    onClick={() => {
                      setEditingProfile({});
                      playSound(click);
                    }}
                  >
                    + {t("profiles.createProfile")}
                  </button>
                </div>
              </div>
            )}
          </div>
        <div className="button-group-2">
          <button
            className="back-btn"
            onClick={() => {
              navigate("/Home");
              playSound(click);
            }}
          >
            ←
          </button>
        </div>  
        </>
      ) : (
        <div className="edit-form">
          <h2>{editingProfile?.id ? t("profiles.editProfile") : t("profiles.createProfile")}</h2>
          <input
            type="text"
            placeholder={t("profiles.pseudo")}
            value={newPseudo}
            onChange={(e) => setNewPseudo(e.target.value)}
          />

          <div className="avatar-grid">
            {avatarList.map((avatar, i) => (
              <img
                key={i}
                src={avatar}
                alt={`avatar-${i}`}
                className={`avatar-option ${
                  newAvatarIndex === i ? "selected" : ""
                }`}
                onClick={() => setNewAvatarIndex(i)}
              />
            ))}
          </div>

          <select
            value={newLangue}
            onChange={(e) => {setNewLangue(e.target.value)
              i18n.changeLanguage(e.target.value);
            }}
          >
            <option value="fr">{t("languages.fr")}</option>
            <option value="en">{t("languages.en")}</option>
          </select>

          <div className="button-group-2">
            <button
              className="bg-Purple-600"
              onClick={() => {
                handleSave();
                playSound(click);
              }}
            >
              {t("common.save")}
            </button>
            <button
              className="bg-White-600"
              onClick={() => {
                setEditingProfile(null);
                playSound(click);
              }}
            >
              {t("common.cancel")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
